import React, { useEffect, useMemo, useRef, useState } from 'react';
import Layout from '../components/Layout';
import HeaderTable from '../components/TableRounded/Header';
import styled from 'styled-components';
import Modal from '../components/Modal';
import { useDropzone } from 'react-dropzone';
import { Col, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { config } from '../config';
import { connect } from 'react-redux';
import Dropzone from '../assets/dropzone.png';
import { format_currency, upload, validate_session } from '../utils';
import toast from 'react-hot-toast';
import MoneyInput from "@rschpdr/react-money-input";
import CloseModal from '../assets/close-modal.png';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Pagination from '../components/Pagination/Pagination';

const Products = (props) => {
    const module = 'Products';
    const [products, setProducts] = useState([]);
    const [beaches, setBeaches] = useState([]);
    const [details, setDetails] = useState({});
    const [filterType, setFilterType] = useState('');
    const [filterBeach, setFilterBeach] = useState('');
    
    const [name, setName] = useState('');
    const [file, setFile] = useState({});
    const [beach, setBeach] = useState('');
    const [type, setType] = useState('');
    const [price, setPrice] = useState('');
    const [order, setOrder] = useState('');
    const [Id, setId] = useState('');
    const [renderFile, setRenderFile] = useState([]);
    const refInputFile = useRef(null);
    const [errors, setErrors] = useState({});

    const [showModalDelete, setShowModalDelete] = useState(false);
    const [showModalCreate, setShowModalCreate] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [showModalDetail, setShowModalDetail] = useState(false);

    useEffect(() => {
        validate_session(props.token);
    },[props.token])

    const onModalCreate = () => {
        if(permissions() && permissions().actionCreate){
            setShowModalCreate(!showModalCreate);
        }else{ messageErrorMessage(`This user doesn't have privileges to perform this action.`); }
    }
    const onModalEdit = () => {
        if(permissions() && permissions().actionEdit){
            setShowModalEdit(!showModalEdit);
        }else{ messageErrorMessage(`This user doesn't have privileges to perform this action.`); }
    }
    const onModalDelete = () => {
        if(permissions() && permissions().actionDelete){
            setShowModalDelete(!showModalDelete);
        }else{ messageErrorMessage(`This user doesn't have privileges to perform this action.`); }
    }
    const onModalDetail = () => setShowModalDetail(!showModalDetail);

    const permissions = () => {
        const data = props.userData;
        if(data.role){
           const action = data.role.modules.filter(m => m.name === module);
           return action[0];
        }else{
            return null;
        }
    }

    const [PageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentTableData, setCurrentTableData] = useState([]);

    useEffect(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        setCurrentTableData(products.slice(firstPageIndex, lastPageIndex));
    }, [currentPage, products, PageSize]);

    const messageError = () => toast.error((t) => (<span>An unexpected error occurred.<a style={{ cursor: 'pointer', marginLeft: 40 }} onClick={() => toast.dismiss(t.id)}>x</a></span>));
    const messageErrorMessage = (message) => toast.error((t) => (<span>{message}<a style={{ cursor: 'pointer', marginLeft: 40 }} onClick={() => toast.dismiss(t.id)}>x</a></span>));

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({
        accept: 'image/*',
        maxFiles: 1,
        onDrop: acceptedFiles => {
            setFile(acceptedFiles[0])
            setRenderFile(URL.createObjectURL(acceptedFiles[0]))
        }
    });

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);

    const refreshData = async () => {
        try{
            const response = await axios.get(`${config.URI}/products`, { headers: { 'Accept': 'application/json', 'content-type': 'application/json', 'Authorization': props.token } });
            if(response.statusText === 'OK'){
                setProducts(response.data.data);
                setReply(response.data.data);
                filtradoGeneral(response.data.data);
            }
        }catch(e){
            console.log(e)
        }
    }

    const encodingData = () => {
        if(permissions() && permissions().actionExport){
            const data = [];
            if(products.length){
                products.map(product => {
                    data.push({ ID: product.code, NAME: product.name, BEACH: product.beach ? product.beach.address.full_address : '', TOTAL_SALES: '$0', TYPE: product.type, PRICE: `$${product.price}`});
                });
            }
            exportToCSV(data);
        }else{ messageErrorMessage(`This user doesn't have privileges to perform this action.`); }
    }

    const exportPDF = () => {
        if(permissions() && permissions().actionExport){
            const unit = "pt";
            const size = "A4"; // Use A1, A2, A3 or A4
            const orientation = "landscape"; // portrait or landscape
        
            const marginLeft = 40;
            const doc = new jsPDF(orientation, unit, size);
        
            doc.setFontSize(15);
        
            const title = "Esteban's Place Products PDF";
            const headers = [['ID', 'NAME', 'BEACH', 'TOTAL SALES', 'TYPE', 'PRICE']];
        
            const data = products.map(product => [product.code, product.name, product.beach ? product.beach.address.full_address : '', '$0', product.type, `$${product.price}`]);
        
            let content = {
            startY: 50,
            head: headers,
            body: data,
            headerStyles: {
                textColor: [0, 0, 0],
                fillColor: [252,249,210]
            }
            };
        
            doc.text(title, marginLeft, 40);
            doc.autoTable(content);
            doc.save("products-estebans-place.pdf");
        }else{ messageErrorMessage(`This user doesn't have privileges to perform this action.`); }
    }

    const exportToCSV = (dataencoding) => {
        const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const ws = XLSX.utils.json_to_sheet(dataencoding);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `products-estebans-place` + fileExtension);
    };

    const refreshBeaches = async () => {
        try{
            const response = await axios.get(`${config.URI}/beaches`, { headers: { 'Accept': 'application/json', 'content-type': 'application/json', 'Authorization': props.token } });
            if(response.statusText === 'OK'){
                setBeaches(response.data.data);
            }
        }catch(e){
            console.log(e);
        }
    }

    useEffect(() => {
        refreshData();
        refreshBeaches();
    }, []);

    const onSubmitDelete = async () => {
        onModalDelete();
        const toastId = toast.loading('Loading...');
        const response = await axios.delete(`${config.URI}/products/${Id}`, { headers: { 'Accept': 'application/json', 'content-type': 'application/json', 'Authorization': props.token } });
        if(response.statusText === 'OK'){
            refreshData();
            setId('');
            toast.success((t) => (<span>Successfully deleted.<a style={{ cursor: 'pointer', marginLeft: 40 }} onClick={() => toast.dismiss(t.id)}>x</a></span>));
        }else{
            messageError();
        }
        toast.dismiss(toastId);
    }

    const onViewModalDelete = (id) => {
        setId(id);
        onModalDelete();
    }

    const onSubmitCreate = async () => {
        if(validation_field()){
            onModalCreate();
            const toastId = toast.loading('Loading...');
            const filename = await upload(file, props.token);
            if(filename){
                const response = await axios.post(`${config.URI}/products`, { name, type, price: price.toString(), beach, file: filename, order },{ headers: { 'Accept': 'application/json', 'Content-type': 'application/json', 'Authorization': props.token } });
                if(response.statusText === 'OK'){
                    refreshData();
                    setName('');
                    setPrice('');
                    setType('');
                    setBeach('');
                    setFile('');
                    filtrado();
                    toast.success((t) => (<span>Successfully saved.<a style={{ cursor: 'pointer', marginLeft: 40 }} onClick={() => toast.dismiss(t.id)}>x</a></span>));
                }else{
                    messageError();
                }
                toast.dismiss(toastId);
            }else{
                toast.dismiss(toastId);
                messageError();
            }
        }
    }

    const validation_field = () => {
        if(name === ''){
            setErrors({ name: true });
            messageErrorMessage(`Invalid name input`);
        }else if(beach === ''){
            setErrors({ beach: true });
            messageErrorMessage(`Don't selected beach`);
        }else if(type === ''){
            setErrors({ type: true });
            messageErrorMessage(`Don't selected type`);
        }else if(price == '0' || price === ''){
            setErrors({ price: true });
            messageErrorMessage(`Invalid price input`);
        }else if(Id === '' && !file.name){
            messageErrorMessage(`Don't selected image`);
        }else{
            setErrors({});
            return true;
        }
    }

    const validation_field_success = () => {
        if(name !== ''){
            setErrors({ name: false })
        }else if(beach !== ''){
            setErrors({ beach: false });
        }else if(type !== ''){
            setErrors({ type: false })
        }else if(price !== ''){
            setErrors({ price: false })
        }
    }

    useEffect(() => {
        validation_field_success();
    },[name, beach, type, price]);

    const onViewDetail = (product) => {
        setDetails({ ...product });
        // setPrice(product.price);
        // setFile(product.file);
        // setType(product.type);
        // setBeach(product.beach._id);
        onModalDetail();
    }

    const onViewModalEdit = (product) => {
        setName(product.name);
        setPrice(product.price);
        setId(product._id);
        setFile(product.file);
        setRenderFile(product.file);
        setType(product.type);
        setBeach(product.beach._id);
        setOrder(product.order)
        onModalEdit();
    }

    const onSubmitEdit = async () => {
        if(validation_field()){
            onModalEdit();
            const toastId = toast.loading('Loading...');
            let filename = null;
            if(typeof file !== 'string'){
                filename = await upload(file, props.token);
            }else{
                filename = file;
            }

            const response = await axios.put(`${config.URI}/products/${Id}`, { name, type, price: price.toString(), beach, file: filename, order },{ headers: { 'Accept': 'application/json', 'Content-type': 'application/json', 'Authorization': props.token } });
            if(response.statusText === 'OK'){
                refreshData();
                setName('');
                setPrice('');
                setType('');
                setBeach('');
                setFile('');
                setId('');
                filtrado();
                toast.success((t) => (<span>Successfully edited.<a style={{ cursor: 'pointer', marginLeft: 40 }} onClick={() => toast.dismiss(t.id)}>x</a></span>));
            }else{
                messageError();
            }
            toast.dismiss(toastId);
        }
    }
    
    const clean = () => {
        setName('');
        setPrice('');
        setType('');
        setBeach('');
        setFile('');
        setId('');
        setOrder('');
        setErrors({});
    }

    const [search, setSearch] = useState('');
    const [reply, setReply] = useState([]);

    const onSearch = (value) => {
        setSearch(value);
        if(value.length > 0){
            const products_search = reply.filter(item => item.name.toLowerCase().search(value.toLowerCase()) !== -1 || item.beach.name.toLowerCase().search(value.toLowerCase()) !== -1);
            setProducts(products_search);
            setCurrentPage(1);
        }
        if(value === ''){
            refreshData();
        }
    }

    useEffect(() => {
        if(PageSize){
            setCurrentPage(1);
        }
    }, [PageSize])

    const filtradoGeneral = (arrReply) => {
        if(filterType !== '' && filterBeach !== ''){
            const products_search_b = arrReply.filter(item => item.beach._id === filterBeach);
            const products_search = products_search_b.filter(item => item.type === filterType);
            setProductsReply(products_search_b);
            orderProducts(products_search);
            setProducts(products_search);
        }
    }

    useEffect(() => {
        if(filterBeach !== '' && filterBeach !== ''){
            const products_search = reply.filter(item => item.beach._id === filterBeach);
            setProductsReply(products_search);
            setProducts(products_search);
            setCurrentPage(1)
        }else{
            refreshData()
        }
    },[filterBeach])

    const [productsReply, setProductsReply] = useState([]);

    const filtrado = () => {
        if(filterType !== '' && filterBeach !== ''){
            const products_search = productsReply.filter(item => item.type === filterType);
            orderProducts(products_search);
            setCurrentPage(1)
        }
    }

    useEffect(() => {
        if(filterType !== '' && filterBeach !== ''){
            const products_search = productsReply.filter(item => item.type === filterType);
            orderProducts(products_search);
            setProducts(products_search);
            setCurrentPage(1)
        }else{
            if(filterType !== ''){
                const products_search = reply.filter(item => item.type === filterType);
                setProducts(products_search);
                setCurrentPage(1)
            }else{
                refreshData()
            }
        }
    },[filterType])

    const [arrayOrder, setArrayOrder] = useState([]);

    const orderProducts = (arrayProductsOrder = []) => {
        let Order = Array.from({length: arrayProductsOrder.length}, (v, i) => (i + 1).toString());
        Order = Order.filter((Or) => arrayProductsOrder.filter(Pr => Pr.order === Or).length === 0);
        setArrayOrder(Order);
    }

    useEffect(() => {
       if(beach !== '' && type !== '' && showModalCreate){
            const tam = products.filter(pr => pr.beach._id === beach && pr.type === type);
            setArrayOrder([tam.length + 1]);
       } 
    },[beach, type])

    const numberValid = (value) => {
        const re = /^[0-9\b]+$/;
        if(value === '' || re.test(value)){
           setOrder(value);
        }
    }

    return(
        <Layout>
            <div className="d-md-flex justify-content-between">
                <div className="d-md-flex mb-sm-10">
                    <Title>Products</Title>
                    <div>
                        <FontAwesomeIcon icon={faSearch} size="sm" style={{ position: 'absolute', marginLeft: 22, marginTop: 14 }} />
                        <SearchInput type="text" placeholder="Search..." onChange={(e) => onSearch(e.target.value)} value={search} className="search-sm" />
                    </div>
                    <div className="d-flex justify-content-between" style={{marginLeft: 10}}>
                        <select className="custom-select" value={filterBeach} onChange={(e) => setFilterBeach(e.target.value)} style={{ fontSize: 14.4, fontFamily: 'Roboto', color: '#1A1A1A', marginLeft: 10, borderColor: '#BDBDBD', borderRadius: 10, height: 40 }}>
                            <option value="">Beach</option>
                            {beaches.map((beach) => (
                                <option value={beach._id}>{beach.name}</option>
                            ))}
                        </select>
                        <select className="custom-select" value={filterType} onChange={(e) => setFilterType(e.target.value)} style={{ fontSize: 14.4, fontFamily: 'Roboto', color: '#1A1A1A', marginLeft: 10, borderColor: '#BDBDBD', borderRadius: 10, height: 40 }}>
                            <option value="">Type</option>
                            <option value="Rental">Rental</option>
                            <option value="Drinks & Snacks">Drinks & Snacks</option>
                        </select>
                    </div>
                </div>
                <div className="button-right-md-sm">
                    <Button bold={'700'} onClick={() => encodingData()}>EXCEL</Button>
                    <Button bold={'700'} onClick={() => exportPDF()}>PDF</Button>
                    <Button backgroundColor={'#4FB4E6'} borderColor={'#4FB4E6'} onClick={() => onModalCreate()} color={'#FFF'} bold={'700'}>CREATE</Button>
                </div>
            </div>
            <div style={{ marginRight: 21 }}>
                <div className="table-responsive">
                    <Table className="table-curved">
                        <HeaderTable header={[{name: 'ID'}, {name: 'Name'}, {name: 'Beach'}, {name: 'Total Sales'}, {name: 'Type'}, {name: 'Price'}, {name: 'Order'}, { name: 'Actions'}]} />
                        {products.length > 0 && (
                            <>
                                {currentTableData.map((product, i) => (
                                    <ContentBody key={i} backgroundColor={((i + 1) % 2) === 0 ? 'rgba(223, 223, 223, 0.2)' : '#FFF'} className="text-center">
                                        <Column className="rowBorderStart">{product.code}</Column>
                                        <Column className="rowBorderMiddle">{product.name}</Column>
                                        <Column className="rowBorderMiddle">{product.beach.name}</Column>
                                        <Column className="rowBorderMiddle">{format_currency(product.sale)}</Column>
                                        <Column className="rowBorderMiddle">{product.type}</Column>
                                        <Column className="rowBorderMiddle">{format_currency(product.price)}</Column>
                                        <Column className="rowBorderMiddle">{product.order}</Column>
                                        <Column className="rowBorderEnd">
                                            <div className="d-flex" style={{ textAlign: 'center', justifyContent: 'center' }}>
                                                <TextAction onClick={() => onViewDetail(product)}>Details&nbsp;</TextAction>-<TextAction onClick={() => onViewModalEdit(product)}>&nbsp;Edit&nbsp;</TextAction>-<TextAction onClick={() => onViewModalDelete(product._id)}>&nbsp;Delete</TextAction>
                                            </div>
                                        </Column>
                                    </ContentBody>
                                ))}
                        </>
                        )}
                    </Table>
                    {products.length > 0 &&
                        <div className="d-flex w-100" style={{marginBottom: 30}}>
                            <div className="d-flex justify-content-start align-items-center" style={{flex: 1}}>
                                <p style={{marginBottom: 0, color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>{(currentPage - 1) * PageSize === 0 ? 1 : (currentPage - 1) * PageSize} - {((currentPage - 1) * PageSize) + PageSize} out of {products.length} items</p>
                            </div>
                            <div className="d-flex justify-content-center align-items-center" style={{flex: 1}}>
                                <p style={{marginBottom: 0, color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>View</p>
                                <select className="custom-select custom-select-sm ml-1 mr-1" value={PageSize + ""} onChange={(e) => setPageSize(+e.target.value)} style={{maxWidth: 67, minHeight: 30}}>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                                <p style={{marginBottom: 0, color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>items per page</p>
                            </div>
                            <div className="d-flex justify-content-end align-items-center" style={{flex: 1}}>
                                <Pagination
                                    className="pagination-bar"
                                    currentPage={currentPage}
                                    totalCount={products.length}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
            <Modal show={showModalDelete} onHide={onModalDelete} dialogClassName="modal-600w" centered>
                <div style={{ height: 32, width: 32, float: 'right', cursor: 'pointer', marginRight: 16, marginTop: 16 }} onClick={() => onModalDelete()}>
                    <img src={CloseModal} style={{ height: '100%', width: '100%' }} />
                </div>
                <div style={{ marginTop: 40, paddingRight: 30, paddingLeft: 30 }}>
                    <TitleModal color="#FF0F00">Delete Product</TitleModal>
                    <TextModal>Please confirm product deletion. Deleted items can be found and recovered from the main menu option.</TextModal>
                    <div style={{ marginTop: 40, marginBottom: 40, textAlign: 'center' }}>
                        <Button backgroundColor="#ECECEC" borderColor="#ECECEC" onClick={() => onModalDelete()} width={'149px'}>Cancel</Button>
                        <Button backgroundColor={'#FF0F00'} borderColor={'#FF0F00'} onClick={() => onSubmitDelete()} width={'149px'} color={'#FFF'}>Delete</Button>
                    </div>
                </div>
            </Modal>
            <Modal show={showModalCreate} onHide={onModalCreate} dialogClassName="modal-600w" centered>
                <div style={{ height: 32, width: 32, float: 'right', cursor: 'pointer', marginRight: 16, marginTop: 16 }} onClick={() => {onModalCreate(); clean();}}>
                    <img src={CloseModal} style={{ height: '100%', width: '100%' }} />
                </div>
                <div style={{ marginTop: 40 , paddingRight: 30, paddingLeft: 30}}>
                    <TitleModal>Create Product</TitleModal>
                    <Form.Group>
                        <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Name</Form.Label>
                        <Form.Control type="text" onChange={(e) => setName(e.target.value)} style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: errors.name ? '#FF0F00' : '#BDBDBD', height: 50, borderRadius: 10}} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Beach</Form.Label>
                        <Form.Control as="select" onChange={(e) => setBeach(e.target.value)} style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: errors.beach ? '#FF0F00' :'#BDBDBD', height: 50, borderRadius: 10}}>
                            <option></option>
                            {beaches.map((beach) => (
                                <option value={beach._id}>{beach.name}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Type</Form.Label>
                                <Form.Control as="select" onChange={(e) => setType(e.target.value)} style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: errors.type ? '#FF0F00' : '#BDBDBD', height: 50, borderRadius: 10}}>
                                    <option></option>
                                    <option value="Rental">Rental</option>
                                    <option value="Drinks & Snacks">Drinks & Snacks</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Price</Form.Label>
                                <MoneyInput onChange={(e) => setPrice(e.target.value)} value={price} currencyConfig={{ locate: "en-US", currencyCode: 'USD' }} className="form-control" style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: '#BDBDBD', height: 50, borderRadius: 10}} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Order</Form.Label>
                                <Form.Control type="text" onChange={(e) => numberValid(e.target.value)} value={order} style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: errors.name ? '#FF0F00' : '#BDBDBD', height: 50, borderRadius: 10}} />
                                {/* <Form.Control as="select" onChange={(e) => setOrder(e.target.value)} style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: errors.type ? '#FF0F00' : '#BDBDBD', height: 50, borderRadius: 10}}>
                                    <option></option>
                                    {arrayOrder.map(Or => (
                                        <option value={Or}>{Or}</option>
                                    ))}
                                </Form.Control> */}
                            </Form.Group>
                        </Col>
                        <Col></Col>
                    </Row>
                    <Form.Group>
                        <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Image</Form.Label>
                        <div>
                            {!file.name ?
                                <div {...getRootProps({style})}>
                                    <input {...getInputProps()} />
                                    <img src={Dropzone} height="80px" alt=""/>
                                    <h5 style={{ fontSize: '18px', fontFamily: 'Arial', color: '#000', marginTop: '15px', marginBottom: 0 }}>Click or Drag-n-Drop an image here</h5>
                                    <p style={{ fontSize: '16px', color: '#000', fontFamily: 'Arial' }}>PNG, JPG Image format</p>
                                </div>
                            :
                                <div style={{ position: 'relative', textAlign: 'center' }}>
                                    <img src={renderFile} style={{ height: 500, width: 500, borderRadius: 10 }} alt="" />
                                    <div style={{ position: 'absolute', right: 10, top: 10 }}>
                                        <Button backgroundColor={'#4FB4E6'} borderColor={'#4FB4E6'} onClick={() => refInputFile.current.click()} paddingVertical={'0.4rem'} color={'#FFF'}>Replace</Button>
                                        <input type="file" accept="image/*" onChange={(e) => { setFile(e.target.files[0]); setRenderFile(URL.createObjectURL(e.target.files[0])); e.target.files = null; }} ref={refInputFile} style={{ display: 'none' }} />
                                    </div>
                                </div>
                            }
                        </div>
                    </Form.Group>
                    <div style={{ marginTop: 40, marginBottom: 40, textAlign: 'center' }}>
                        <Button backgroundColor="#ECECEC" borderColor="#ECECEC" onClick={() => {onModalCreate(); clean();}} width={'149px'}>Cancel</Button>
                        <Button backgroundColor={'#4FB4E6'} borderColor={'#4FB4E6'} onClick={() => onSubmitCreate()} width={'149px'} color={'#FFF'}>Save</Button>
                    </div>
                </div>
            </Modal>
            <Modal show={showModalDetail} onHide={onModalDetail} dialogClassName="modal-600w" noPadding={true} centered>
                <div style={{ height: 32, width: 32, float: 'right', cursor: 'pointer', marginRight: 16, marginTop: 16 }} onClick={() => onModalDetail()}>
                    <img src={CloseModal} style={{ height: '100%', width: '100%' }} />
                </div>
                <div style={{ marginTop: 40 }}>
                    <TitleModal>Product Details</TitleModal>
                </div>
                <table className="table table-striped table-collapse padding-horizontal-1rem" style={{marginTop: 35}}>
                    <tbody>
                        <tr>
                            <TitleDetails>ID</TitleDetails>
                            <td>{details.code ? details.code : ''}</td>
                        </tr>
                        <tr>
                            <TitleDetails>NAME</TitleDetails>
                            <td>{details.name ? details.name : ''}</td>
                        </tr>
                        <tr>
                            <TitleDetails>Beach</TitleDetails>
                            <td>{details.beach ? details.beach.name : ''}</td>
                        </tr>
                        <tr>
                            <TitleDetails>Total Sales</TitleDetails>
                            <td>{details.sale ? format_currency(details.sale) : '$ 0'}</td>
                        </tr>
                        <tr>
                            <TitleDetails>TYPE</TitleDetails>
                            <td>{details.type ? details.type : ''}</td>
                        </tr>
                        <tr>
                            <TitleDetails>Price</TitleDetails>
                            <td>{details.price ? format_currency(details.price) : ''}</td>
                        </tr>
                        <tr>
                            <TitleDetails>Order</TitleDetails>
                            <td>{details.order ? details.order : ''}</td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ textAlign: 'center' }}>
                    <img src={details.file ? details.file : ''} style={{ height: 500, width: 500 }} alt="product" />
                </div>
                <div style={{ marginTop: 40, marginBottom: 40, textAlign: 'center' }}>
                    <Button backgroundColor={'#ECECEC'} borderColor={'#ECECEC'} width="149px" onClick={() => onModalDetail()}>Close</Button>
                </div>
            </Modal>
            <Modal show={showModalEdit} onHide={onModalEdit} dialogClassName="modal-600w" centered>
                <div style={{ height: 32, width: 32, float: 'right', cursor: 'pointer', marginRight: 16, marginTop: 16 }} onClick={() => {clean();onModalEdit()}}>
                    <img src={CloseModal} style={{ height: '100%', width: '100%' }} />
                </div>
                <div style={{ marginTop: 40, paddingRight: 30, paddingLeft: 30 }}>
                    <TitleModal>Edit Product</TitleModal>
                    <Form.Group>
                        <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Name</Form.Label>
                        <Form.Control type="text" onChange={(e) => setName(e.target.value)} defaultValue={name} style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: errors.name ? '#FF0F00' : '#BDBDBD', height: 50, borderRadius: 10}} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Beach</Form.Label>
                        <Form.Control as="select" onChange={(e) => setBeach(e.target.value)} defaultValue={beach} style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: errors.beach ? '#FF0F00' :'#BDBDBD', height: 50, borderRadius: 10}}>
                            <option></option>
                            {beaches.map((beach) => (
                                <option value={beach._id}>{beach.name}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Type</Form.Label>
                                <Form.Control as="select" onChange={(e) => setType(e.target.value)} defaultValue={type} style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: errors.type ? '#FF0F00' : '#BDBDBD', height: 50, borderRadius: 10}}>
                                    <option></option>
                                    <option value="Rental">Rental</option>
                                    <option value="Drinks & Snacks">Drinks & Snacks</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Price</Form.Label>
                                <MoneyInput onChange={(e) => setPrice(e.target.value)} value={price} currencyConfig={{ locate: "en-US", currencyCode: 'USD' }} className="form-control" style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: '#BDBDBD', height: 50, borderRadius: 10}} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Order</Form.Label>
                                <Form.Control type="text" onChange={(e) => numberValid(e.target.value)} value={order} style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: errors.name ? '#FF0F00' : '#BDBDBD', height: 50, borderRadius: 10}} />
                                {/* <Form.Control as="select" onChange={(e) => setOrder(e.target.value)} defaultValue={order} style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto', borderColor: errors.type ? '#FF0F00' : '#BDBDBD', height: 50, borderRadius: 10}}>
                                    <option></option>
                                    {arrayOrder.map(Or => (
                                        <option value={Or}>{Or}</option>
                                    ))}
                                </Form.Control> */}
                            </Form.Group>
                        </Col>
                        <Col></Col>
                    </Row>
                    <Form.Group>
                        <Form.Label style={{color: '#1A1A1A', fontSize: 14, fontFamily: 'Roboto'}}>Image</Form.Label>
                        <div>
                            {!file.name && typeof file !== 'string' ?
                                <div {...getRootProps({style})}>
                                    <input {...getInputProps()} />
                                    <img src={Dropzone} height="80px" alt=""/>
                                    <h5 style={{ fontSize: '18px', fontFamily: 'Arial', color: '#000', marginTop: '15px', marginBottom: 0 }}>Click or Drag-n-Drop an image here</h5>
                                    <p style={{ fontSize: '16px', color: '#000', fontFamily: 'Arial' }}>PNG, JPG Image format</p>
                                </div>
                            :
                                <div style={{ position: 'relative', textAlign: 'center' }}>
                                    <img src={renderFile} style={{ height: 500, width: 500, borderRadius: 10 }} alt="" />
                                    <div style={{ position: 'absolute', right: 10, top: 10 }}>
                                        <Button backgroundColor={'#4FB4E6'} borderColor={'#4FB4E6'} onClick={() => refInputFile.current.click()} paddingVertical={'0.4rem'} color={'#FFF'}>Replace</Button>
                                        <input type="file" accept="image/*" onChange={(e) => { setFile(e.target.files[0]); setRenderFile(URL.createObjectURL(e.target.files[0])); e.target.files = null; }} ref={refInputFile} style={{ display: 'none' }} />
                                    </div>
                                </div>
                            }
                        </div>
                    </Form.Group>
                    <div style={{ marginTop: 40, marginBottom: 40, textAlign: 'center' }}>
                        <Button backgroundColor="#ECECEC" borderColor="#ECECEC" onClick={() => {clean();onModalEdit()}} width={'149px'}>Cancel</Button>
                        <Button backgroundColor={'#4FB4E6'} borderColor={'#4FB4E6'} onClick={() => onSubmitEdit()} width={'149px'} color={'#FFF'}>Save</Button>
                    </div>
                </div>
            </Modal>
        </Layout>
    )
}

const TitleDetails = styled.td`
font-size: 14px;
font-family: 'Roboto';
font-weight: 700;
text-transform: uppercase;
color: #1A1A1A;
`;
const TextAction = styled.p`
font-size: 14px;
font-family: 'Roboto';
text-decoration-line: underline;
cursor: pointer;
color: #1A1A1A;
align-items: center;
margin-bottom: 0;
margin-top: none !important;
line-height: none !important;
`;
const SearchInput = styled.input`
border: 1px solid #BDBDBD;
color: #1A1A1A;
border-radius: 10px;
height: 40px;
width: 316px;
margin-left: 10px;
padding-left: 35px;
`;
const Title = styled.h1`
font-family: 'Montserrat';
font-weight: 700;
font-size: 28px;
line-height: 34px;
color: #000;
`;
const Button = styled.button`
background: ${({backgroundColor}) => backgroundColor ? backgroundColor : 'transparent'};
border: 1px solid ${({borderColor}) => borderColor ? borderColor : '#1A1A1A'};
color: ${({color}) => color ? color : '#000'};
border-radius: 10px;
height: ${({height}) => height ? height : '40px'};
width: ${({width}) => width ? width : '100px'};
font-size: 14px;
line-height: 16px;
font-weight: ${({bold}) => bold ? bold : '400'};
font-family: 'Roboto';
margin-right: 5px;
`;
const Table = styled.table`
border: none !important;
display: table;
margin-bottom: 1rem;
width: 100%;
margin-top: 18px;
margin-bottom: 18px;
`;
const ContentBody = styled.tr`
background-color: ${({backgroundColor}) => backgroundColor ? backgroundColor : '#FFF'}; 
margin-top: 10px;
margin-bottom: 10px;
`;
const Column = styled.td`
color: #1A1A1A;
padding: .8rem;
font-size: 14px;
line-height: 16px;
font-family: 'Roboto';
`;
const TitleModal = styled.h1`
font-family: 'Montserrat';
color: ${({color}) => color ? color: '#1A1A1A'};
font-size: 24px;
line-height: 29px;
font-weight: 700;
text-align: center;
`;
const TextModal = styled.p`
font-family: 'Roboto';
color: #1A1A1A;
font-size: 16px;
text-align: center;
`;
const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 3,
    borderRadius: 10,
    borderStyle: 'dotted',
    borderColor: '#BDBDBD',
    backgroundColor: '#FFFFFF',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};
const activeStyle = {
    borderColor: '#2196f3'
};
const acceptStyle = {
    borderColor: '#00e676'
};
const rejectStyle = {
    borderColor: '#ff1744'
};
const mapStateToProps = state => ({
	token: state.auth.token,
    userData:  state.auth.userData
})

export default connect(mapStateToProps)(Products);